
import { Options, Vue } from 'vue-class-component'
import { DeviceInfoFirstLevel, ParamTableField } from '@/module/response'
import { Tool } from '@/module/tool'
import TableFieldShow from '@/components/TableFieldShow/TableFieldShow.vue'
import { Language } from '@/module/language'

interface SoreList {
    field: string;
    sort: boolean; // true是升序，false降序
}

@Options({
  components: { TableFieldShow },
  props: ['homeInfoData'],
  emits: {
    click: null,
    openchart: () => {
      return true
    },
    setAsMainProduct: () => {
      return true
    }
  },
  watch: {
    homeInfoData () {
      this.initData()
    }
  }
})
export default class SalesTable extends Vue {
    initTableList: DeviceInfoFirstLevel[] = [];
    tableList: DeviceInfoFirstLevel[] = [];
    sortList: SoreList[] = [];
    tableH = 0;
    tableW = 0;
    top = 'top:56px'
    tableBox1Width = 'width: 2500px'
    tableBox2Width = 'width: 2500px'
    tableBoxWidth = 0

    number=0;

    sortField = '';

    showTableFieldKeys: ParamTableField[] = [
      // { text: '存货编码', isShow: false },
      // { text: '存货名称', isShow: false },
      // { text: '规格型号', isShow: false },
      // { text: '商品名称', isShow: true },
      // { text: '颜色键轴', isShow: true },
      // { text: '京东库存', isShow: false },
      // { text: '天猫库存', isShow: false },
      // { text: 'U8库存', isShow: false }
      // { text: this.$i18n.t('productCode'), isShow: false },
      // { text: this.$i18n.t('stockName'), isShow: false },
      // { text: this.$i18n.t('prdocutModel'), isShow: false },
      // { text: this.$i18n.t('productName'), isShow: true },
      // { text: this.$i18n.t('productColor'), isShow: true },
      // { text: this.$i18n.t('jdStock'), isShow: false },
      // { text: this.$i18n.t('tmStock'), isShow: false },
      // { text: this.$i18n.t('u8Stock'), isShow: false }
    ];

    created () {
      this.initShowTableFieldKeys()
    }

    mounted () {
      this.initSize()
      this.tableScroll()
    }

    initShowTableFieldKeys () {
      this.showTableFieldKeys = [
        { text: this.$i18n.t('productCode'), isShow: false },
        { text: this.$i18n.t('stockName'), isShow: false },
        { text: this.$i18n.t('prdocutModel'), isShow: false },
        { text: this.$i18n.t('productName'), isShow: true },
        { text: this.$i18n.t('productColor'), isShow: true },
        { text: this.$i18n.t('jdStock'), isShow: false },
        { text: this.$i18n.t('tmStock'), isShow: false },
        { text: this.$i18n.t('u8Stock'), isShow: false }
        // { text: this.$i18n.t('operate'), isShow: false }
      ]
    }

    initSize () {
      const cw = document.body.clientWidth - 60
      const ch = window.screen.height - 460
      this.tableW = cw
      this.tableH = ch
      this.tableBoxWidth = cw
      this.tableBox1Width = 'width: ' + cw + 'px'
      this.tableBox2Width = 'width: ' + cw + 'px'
      if (Language.get() === Language.en) {
        this.top = 'top:86px'
      } else {
        this.top = 'top:56px'
      }
    }

    tableScroll () {
      const theadBox = document.getElementById('thead_box') as HTMLElement
      const tableBox = document.getElementById('table_box') as HTMLElement
      tableBox.addEventListener('scroll', () => {
        theadBox.scrollTo(tableBox.scrollLeft, 0)
      })
    }

    initData () {
      const list: DeviceInfoFirstLevel[] = this.$props.homeInfoData.deviceInfo
      if (list !== null) {
        const find = list.find((value) => {
          return value.catId === 0
        })
        this.tableList = list.filter((value) => {
          return value.catId > 0
        })
        if (find !== undefined) {
          find.deviceInfo.forEach((value) => {
            this.tableList.push({
              catId: 0,
              name: value.productName,
              tMallSale: value.tMallSale,
              jdSale: value.jdSale,
              allSale: value.allSale,
              tMallStorage: value.tMallStorage,
              jdStorage: value.jdStorage,
              u8Storage: value.u8Storage,
              storageSaleDay: value.storageSaleDay,
              tMallDataDay: value.tMallDataDay,
              jdDataDay: value.jdDataDay,
              isfocus: value.isfocus,
              deviceId: [value.id],
              deviceInfo: [],

              code: value.code,
              productName: value.name,
              model: value.model,
              attribute: value.attribute,
              returnRate: value.returnRate,
              totalStorage: value.totalStorage,
              salesGrowthFactor: value.salesGrowthFactor
            })
          })
        }
        this.initTableList = this.tableList
        this.tableList = this.tableList.filter((value) => {
          return value.isfocus === true
        })
      }
    }

    switchFocus (b: boolean) {
      if (b) {
        this.tableList = this.initTableList.filter((value) => {
          return value.isfocus === b
        })
      } else {
        this.tableList = this.initTableList
      }
    }

    changeLevel2Show (index: number) {
      const el = document.querySelectorAll('.level2_table_' + index)
      const showLevel2ButtonEl = document.getElementById(
        'show_level2_button_' + index
      ) as HTMLElement
      const status = showLevel2ButtonEl.innerHTML
      if (status === 'keyboard_arrow_down') {
        el.forEach((element) => {
          element.classList.remove('level2_table')
        })
        showLevel2ButtonEl.innerHTML = 'keyboard_arrow_up'
      } else {
        el.forEach((element) => {
          element.classList.add('level2_table')
        })
        showLevel2ButtonEl.innerHTML = 'keyboard_arrow_down'
      }
    }

    sortTableList (field: string) {
      const oldField = this.sortField
      const currentField = this.sortList.find((value) => {
        return value.field === field
      })
      this.sortField = field
      let order = false

      if (currentField === undefined) {
        this.sortList.push({
          field: field,
          sort: true
        })
        order = true
      } else {
        currentField.sort = Boolean(currentField.sort === false ? 1 : 0)
        order = currentField.sort
        this.changeSortType(field, order)
      }
      this.activeSortField(field, oldField)

      this.tableList.sort(Tool.sortBy(field, order))
    }

    activeSortField (field: string, oldField: string) {
      if (field !== oldField) {
        const fieldEl = document.getElementById(field + 'Sort') as Element
        if (fieldEl !== null) {
          fieldEl.classList.add('header_button_active')
        }
        const oldFieldEl = document.getElementById(oldField + 'Sort') as Element
        if (oldFieldEl !== null) {
          oldFieldEl.classList.remove('header_button_active')
        }
      }
    }

    changeSortType (field: string, order: boolean) {
      const fieldEl = document.getElementById(field + 'Sort') as Element
      if (fieldEl !== null) {
        fieldEl.innerHTML = order ? 'south' : 'north'
      }
    }

    showTableField (key: number) {
      if (this.showTableFieldKeys[key].isShow === true) {
        if (key !== 3 && key !== 4) {
          this.tableBoxWidth = this.tableBoxWidth - 200
          this.tableBox1Width = 'width: ' + this.tableBoxWidth + 'px'
          this.tableBox2Width = 'width: ' + this.tableBoxWidth + 'px'
        }
        this.showTableFieldKeys[key].isShow = false
      } else {
        if (key !== 3 && key !== 4) {
          this.tableBoxWidth = this.tableBoxWidth + 200
          this.tableBox1Width = 'width: ' + this.tableBoxWidth + 'px'
          this.tableBox2Width = 'width: ' + this.tableBoxWidth + 'px'
        }
        this.showTableFieldKeys[key].isShow = true
      }
    }

    dateFormat (date: Date) {
      return Tool.dateFormat(date)
    }
}
